var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("CreateLocationDialog", { ref: "createLocationDialog" }),
      _vm._v(" "),
      _c("EditLocationDialog", { ref: "editLocationDialog" }),
      _vm._v(" "),
      _c(
        "v-card-actions",
        { staticClass: "card-bg-1 py- layout wrap" },
        [
          _c(
            "v-btn",
            {
              attrs: { color: "success" },
              on: {
                click: function ($event) {
                  return _vm.CreateLocationDialog()
                },
              },
            },
            [
              _c("v-icon", { staticClass: "mr-2" }, [_vm._v("add")]),
              _vm._v(" "),
              _c("div", { staticClass: "text-capitalize" }, [
                _vm._v("\n        Create monitoring location..\n      "),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("v-divider"),
      _vm._v(" "),
      _c(
        "v-layout",
        { staticClass: "align-baseline py-2" },
        [
          _c(
            "v-item-group",
            {
              attrs: { mandatory: "", "active-class": "white--text" },
              model: {
                value: _vm.filterToggle,
                callback: function ($$v) {
                  _vm.filterToggle = $$v
                },
                expression: "filterToggle",
              },
            },
            [
              _c(
                "v-subheader",
                { staticStyle: { display: "inline", cursor: "default" } },
                [_vm._v("Show:")]
              ),
              _vm._v(" "),
              _c("v-item", {
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ active, toggle }) {
                      return _c(
                        "v-chip",
                        {
                          staticClass: "chipFilter clickable",
                          attrs: {
                            small: "",
                            color: active ? "primary" : "default",
                            selected: active,
                          },
                          on: { click: toggle },
                        },
                        [_vm._v("All")]
                      )
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("v-item", {
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ active, toggle }) {
                      return _c(
                        "v-chip",
                        {
                          staticClass: "chipFilter clickable",
                          attrs: {
                            small: "",
                            color: active ? "primary" : "default",
                            selected: active,
                          },
                          on: { click: toggle },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "pr-2",
                              class: {
                                "error--text font-weight-bold":
                                  _vm.noDataTypeItems.length > 0,
                              },
                              staticStyle: { float: "left" },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.noDataTypeItems.length)
                              ),
                            ]
                          ),
                          _vm._v("\n          Empty\n        "),
                        ]
                      )
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _c("v-text-field", {
            staticClass: "rounded emphasize-clear",
            attrs: {
              "prepend-inner-icon": "search",
              clearable: "",
              solo: "",
              placeholder: "Search monitoring locations",
              "hide-details": "",
            },
            model: {
              value: _vm.search,
              callback: function ($$v) {
                _vm.search = $$v
              },
              expression: "search",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("v-divider"),
      _vm._v(" "),
      _c("v-data-table", {
        staticClass: "elevation-1",
        attrs: {
          headers: _vm.headers,
          pagination: _vm.pagination,
          items: _vm.filteredItems,
          search: _vm.search,
        },
        on: {
          "update:pagination": function ($event) {
            _vm.pagination = $event
          },
        },
        scopedSlots: _vm._u([
          {
            key: "items",
            fn: function ({ item }) {
              return [
                _c("td", [
                  _c(
                    "div",
                    [
                      _c(
                        "v-icon",
                        { staticClass: "mr-2", attrs: { small: "" } },
                        [_vm._v("open_in_new")]
                      ),
                      _vm._v(" "),
                      _c(
                        "router-link",
                        {
                          attrs: {
                            target: "_blank",
                            to: {
                              name: "monitoringfeature",
                              params: { monitoringFeatureId: item.id },
                            },
                          },
                        },
                        [_c("strong", [_vm._v(_vm._s(item.primaryName))])]
                      ),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "td",
                  [
                    _vm._l(item.dataTypes, function (dataSource, index) {
                      return _c(
                        "v-chip",
                        {
                          key: `dataSource-${index}`,
                          attrs: { label: "", small: "" },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(dataSource.station.LocationIdentifier) +
                              " [" +
                              _vm._s(dataSource.type) +
                              "]\n        "
                          ),
                        ]
                      )
                    }),
                    _vm._v(" "),
                    item.dataTypes.length == 0
                      ? _c(
                          "v-chip",
                          {
                            attrs: {
                              outline: "",
                              color: "error",
                              small: "",
                              label: "",
                            },
                          },
                          [_vm._v("\n          No data types\n        ")]
                        )
                      : _vm._e(),
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticClass: "text-xs-center" },
                  [
                    _c(
                      "v-tooltip",
                      {
                        attrs: { "open-delay": 500, left: "" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function ({ on }) {
                                return [
                                  _c(
                                    "v-btn",
                                    _vm._g(
                                      {
                                        attrs: { icon: "" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.editItem(item)
                                          },
                                        },
                                      },
                                      on
                                    ),
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { color: "warning" } },
                                        [_vm._v("edit")]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      },
                      [
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(_vm.$t("Button.Edit")))]),
                      ]
                    ),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }